import { orderBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";
import { dummy_tipos_uso } from "../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import { estruturaTodasAtvs, typeInsumos } from "../../atvsTodas/meta/estrutura_todas_atvs";


// export type typeInsumos = {
//     insumo_nome: string;
//     cod_tipo: number;
//     dosagem: number;
//     quantidade: number;
//     cod_medida: number;
//     calculo_dosagem: string;
//     ordem: number;
//     cod_atividade: number;
//     descricao_atv: string;
//     data_inicio: string | null;
//     quantidade_insumo: string;
//     nome_medida: string;
//     tipo_nome: string;
//     porcentagem_remonte?: number;
//     cod_insumo: number;
// }

export type typeInsumosPorTalhao = {
    cod_talhao: number;
    nome_talhao: string;
    area: number;
    lista_insumos: typeInsumos[];
}

export type typeEstruturaTodasAtvs = {
    cod_propriedade: number;
    nome_propriedade: string;
    lista_insumos_por_talhao: typeInsumosPorTalhao[];
};


export function estruturaPlanejamentoInsumos(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade_selecionada: number,
    cod_talhao_selecionado: number,
    cod_subarea_selecionada: number,
): typeEstruturaTodasAtvs[] {

    const estrutura_todas_atvs = estruturaTodasAtvs(data_atividades, data_propriedades, [], cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);

    const estrutura_insumos = (estrutura_todas_atvs ?? []).map(prop => {
        return {
            cod_propriedade: prop.cod_propriedade,
            nome_propriedade: prop.nome_propriedade,
            lista_insumos_por_talhao: (prop.lista_atividades_por_talhao).map(talhoes => {
                const insumos = (talhoes.lista_atividades ?? []).map(atv => {
                    return {
                        ...atv,
                        insumos: (atv.insumos ?? []).map(insumo => {
                            return {
                                ...insumo,
                                tipo_nome: dummy_tipos_uso.find(t => t.cod === insumo.cod_tipo)?.nome || "",
                                cod_atividade: atv.cod,
                                descricao_atv: atv.descricao,
                                data_inicio: atv.data_inicio,
                                data_final: atv.data_final,
                                porcentagem_remonte: atv.porcentagem_remonte,
                            }
                        })
                    }
                    //@ts-ignore
                }).flatMap(atv => atv.insumos);
                return {
                    nome_talhao: talhoes.nome_talhao,
                    cod_talhao: talhoes.cod_talhao,
                    area: talhoes.area,
                    lista_insumos: orderBy(insumos, 'data_inicio', 'asc')
                }
            })
        }
    });

    if (cod_propriedade_selecionada) {
        const filtro_propriedade = estrutura_insumos.filter(i => i.cod_propriedade === cod_propriedade_selecionada) ?? [];

        if (cod_talhao_selecionado) {
            if (cod_subarea_selecionada) {
                return filtro_propriedade?.map(i => {
                    return {
                        ...i,
                        lista_insumos_por_talhao: i.lista_insumos_por_talhao.filter(i => i.cod_talhao === cod_subarea_selecionada) ?? []
                    }
                })
            }
            return filtro_propriedade?.map(i => {
                return {
                    ...i,
                    lista_insumos_por_talhao: i.lista_insumos_por_talhao.filter(i => i.cod_talhao === cod_talhao_selecionado) ?? []
                }
            });
        }
        return filtro_propriedade;
    }

    return estrutura_insumos ?? [];
};